import React, { useState } from 'react';
import { getCopyText } from '../../lib/copyFormatters';
import { getCopyHTML } from '../../lib/copyFormatters/indexHTML';

interface CopyButtonProps {
  agentType?: string;
  agentOutput: any;
}

const CopyButton: React.FC<CopyButtonProps> = ({ agentType, agentOutput }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const htmlContent = getCopyHTML(agentType, agentOutput);
    const textContent = getCopyText(agentType, agentOutput);

    try {
      // Try to write both HTML and plain text to clipboard
      // Apps like Google Sheets, Word, etc. will use the HTML version
      // Plain text editors will use the text version
      await navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([htmlContent], { type: 'text/html' }),
          'text/plain': new Blob([textContent], { type: 'text/plain' }),
        }),
      ]);
    } catch (err) {
      // Fallback to plain text if ClipboardItem is not supported
      console.warn('Rich text copy not supported, falling back to plain text', err);
      await navigator.clipboard.writeText(textContent);
    }

    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      onClick={handleCopy}
      className="text-xs text-gray-500 hover:text-gray-700 mt-2 transition-colors duration-200"
    >
      {copied ? (
        <span className="flex items-center gap-1">
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
          Copied!
        </span>
      ) : (
        <span className="flex items-center gap-1">
          <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H6m2-4h2"
            />
          </svg>
          Copy
        </span>
      )}
    </button>
  );
};

export default CopyButton;
